/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box, makeStyles, TextField, Checkbox, ListItemText,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import {
  React, useEffect, useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import PageBanner from '../../components/utils/PageBanner';
import SimpleAlert from '../../components/utils/SimpleAlert';
import AssetManagementFiltersBar from '../../components/FilterBar';
// Local imports
import { useProject } from '../../config/ProjectContext';
import DeploymentAccordion from '../../components/DeploymentList/DeploymentAccordion';
import GraphqlService from '../../service/graphqlService';
import YesNoDialog from '../../components/utils/YesNoDialog';
import PaginationComponent from '../../components/Pagination';
import ProgressDialog from '../../components/utils/ProgressDialog';
import { useSnackbar } from '../../providers/SnackbarContext';
import MessageCard from '../../components/utils/MessageCard';
import useRegionFeatureGate from '../../hooks/useRegionFeatureGate';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  index: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired,
};

export default function DeploymentList() {
  const useStyles = makeStyles((theme) => ({
    separate: {
      flexWrap: 'noWrap',
    },
    headerTabPanel: {
      height: 48,
      backgroundColor: theme.palette.background.paper,
    },
    pagination: {
      background: theme.palette.background.paper,
      borderRadius: 12,
      boxShadow: theme.customShadows.regularShadow,
      color: theme.palette.primary.text,
      float: 'right',
      padding: 0,
      width: '100%',
    },
    labelHeaderTabPanel: {
      color: theme.palette.primary.subMain,
      fontFamily: theme.typography.h3.fontFamily,
      fontSize: '16px',
      fontWeight: theme.typography.fontWeightBold,
      letterSpacing: '0',
      lineHeight: '19px',
      textAlign: 'center',
      width: '720px',
      height: '48px',
    },
    background: {
      backgroundColor: theme.palette.background.default,
    },
    button: {
      float: 'right',
      margin: '0 0 16px 24px',
    },
    tableIcons: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: 24,
      flexWrap: 'wrap',
    },
    filtersContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      padding: theme.spacing(3),
      gap: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderRadius: 12,
      marginBottom: theme.spacing(2),
      boxShadow: theme.customShadows.regularShadow,
      flexWrap: 'wrap',
    },
    selectPaginationSize: {
      marginRight: '8px',
      borderRadius: 12,
    },
    fileTypeFilterStyle: {
      minWidth: 210,
      marginTop: 6,
    },
    orderDateStyle: {
      minWidth: 130,
      marginTop: 6,
    },
    deployIdFilterStyle: {
      minWidth: 450,
      borderRadius: 12,
      marginRight: 8,
    },
  }));

  const [currentPage, setCurrentPage] = useState(0);
  const [deleted, setDeleted] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { project } = useProject();
  const { deploymentID: deploymentIDParam } = useParams();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertId, setAlertId] = useState('');
  const [alertText, setAlertText] = useState('');
  const [yesNoDialogOpen, setYesNoDialogOpen] = useState(false);
  const [deployToDelete, setDeployToDelete] = useState(() => { });
  const [yesNoDialogText, setYesNoDialogText] = useState('');
  const [sortDirection, setSortDirection] = useState('DESC');
  const [lastProjectCode, setLastProjectCode] = useState(null);
  const [deploymentFileTypeFilter, setDeploymentFileTypeFilter] = useState(null);
  const [selectedDeploymentFileTypes, setSelectedDeploymentFileTypes] = useState([]);
  const [openDeploymentTypeFilter, setOpenDeploymentTypeFilter] = useState(false); // State to control the open state of the dropdown

  const [lastDeploymentFileTypeFilter, setLastDeploymentFileTypeFilter] = useState();
  const openSnackBar = useSnackbar();

  const isFeatureAvailable = useRegionFeatureGate();

  const [filterByDescription, setFilterByDescription] = useState('');
  const [_debouncedDescription, setDebouncedDescription] = useState('');
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);
  const [hasInitializedSearch, setHasInitializedSearch] = useState(false);
  const [filterByDeploymentId, setFilterByDeploymentId] = useState('');
  const [_debouncedDeploymentId, setDebouncedDeploymentId] = useState('');

  // const { deploymentID: deploymentIDParam } = useParams();

  // Trigger automatic search on initial page load
  useEffect(() => {
    if (!hasInitializedSearch && project?.code) {
      setIsSearchTriggered(true);
      setHasInitializedSearch(true);
    }
  }, [project?.code, hasInitializedSearch]);

  const getFileType = deploymentFileTypeFilter === null ? null : deploymentFileTypeFilter;

  function openAlert(header, text, id) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
    setAlertId(id);
  }

  const getDeployment = async (deploymentID) => GraphqlService.getDeployment({
    projectId: project?.code,
    deploymentID,
  });

  useQuery(['deployment', deploymentIDParam, project?.code], () => getDeployment(deploymentIDParam), {
    enabled: !!deploymentIDParam && !!project?.code,
    cacheTime: 0,
  });

  const fetchDeployments = async () => {
    if (!isSearchTriggered) return { data: [], pagination: null };
    
    if (project?.code !== lastProjectCode || deploymentFileTypeFilter !== lastDeploymentFileTypeFilter) {
      setCurrentPage(0);
      setLastProjectCode(project?.code);
      setLastDeploymentFileTypeFilter(deploymentFileTypeFilter);
    }

    // If filtering by deployment ID, fetch only that deployment
    if (_debouncedDeploymentId) {
      try {
        const deployment = await getDeployment(_debouncedDeploymentId);
        return {
          data: deployment ? [deployment] : [],
          pagination: { totalItems: deployment ? 1 : 0 }, // Mock pagination
        };
      } catch (error) {
        console.error('Error fetching deployment by ID:', error);
        return { data: [], pagination: { totalItems: 0 } }; // Return empty result on error
      }
    }

    return GraphqlService.listDeployments({
      projectId: project?.code,
      page: currentPage,
      pageSize,
      sortDirection,
      fileType: getFileType,
      deployDescriptionKey: _debouncedDescription && _debouncedDescription !== '' ? 'UserDescription' : null,
      deployDescriptionValue: _debouncedDescription,
      deleted,
    });
  };

  const {
    data: deployments,
    error: errorFetchingDeployments,
    isLoading,
    refetch,
  } = useQuery(['deployments', project?.code, currentPage, pageSize, sortDirection, deploymentFileTypeFilter, _debouncedDescription, _debouncedDeploymentId, deleted, isSearchTriggered], () => fetchDeployments({
    projectId: project?.code,
    page: currentPage,
    pageSize: 10,
    sortDirection,
    fileType: getFileType,
    deleted,
  }), {
    enabled: !!project?.code,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    cacheTime: 0,
  });

  const fetchDeploymentFileTypes = async () => GraphqlService.getDeploymentFileTypes({
    projectId: project?.code,
  });

  const {
    data: deploymentFileTypes,
    error: errorFetchingDeploymentFileTypes,
    isLoading: isLoadingDeploymentFileTypes,
  } = useQuery(['deploymentFileTypes', project?.code, currentPage, pageSize, sortDirection], () => fetchDeploymentFileTypes({
    projectId: project?.code,
  }), {
    enabled: !!project?.code && isFeatureAvailable('deploymentFileTypes'),
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    cacheTime: 0,
  });

  async function deleteDeploy(deploy) {
    try {
      await GraphqlService.deleteDeploy(project?.code, deploy.deploymentID);
      refetch();
    } catch (error) {
      openAlert('Error', `Error deleting deployment for asset ${deploy.file.type}: ${error.message}`, 'closeAlertDeleteDeploymentError');
    }
  }

  useEffect(() => {
    if (errorFetchingDeploymentFileTypes && isFeatureAvailable('deploymentFileTypes')) {
      openSnackBar('Error fetching Deployment File Types', 'error');
    }
  }, [errorFetchingDeploymentFileTypes, openSnackBar]);

  const handleSearchClick = () => {
    if (filterByDescription) {
      setDebouncedDescription(filterByDescription);
    } else {
      setDebouncedDescription('');
    }
    if (filterByDeploymentId) {
      setDebouncedDeploymentId(filterByDeploymentId);
    } else {
      setDebouncedDeploymentId('');
    }
    setIsSearchTriggered(true);
  };

  const handleFilterChipDelete = (filterName) => {
    if (filterName === 'description') {
      setFilterByDescription('');
      setDebouncedDescription('');
    } else if (filterName === 'deploymentId') {
      setFilterByDeploymentId('');
      setDebouncedDeploymentId('');
    } else if (filterName === 'status') {
      setDeleted(0);
    } else if (filterName === 'sortDirection') {
      setSortDirection('DESC');
    } else if (filterName === 'assetTypes') {
      setSelectedDeploymentFileTypes([]);
      setDeploymentFileTypeFilter(null);
    }
    setIsSearchTriggered(true);
  };

  const handleDeletedSelectionChange = (event) => {
    setDeleted(event.target.value);
  };

  const handleOrderByChange = (event) => {
    setSortDirection(event.target.value);
  };

  const handleDeploymentFileTypeFilterChange = (event) => {
    const { value } = event.target;
    // Need to handle the selection as an array
    setSelectedDeploymentFileTypes(value);
    // transform the array in a string with values sepparated by commas
    if (!value) {
      setDeploymentFileTypeFilter(null);
    } else setDeploymentFileTypeFilter(value.join(',').toString());
  };

  const handleClose = () => {
    setOpenDeploymentTypeFilter(false);
  };

  const handleOpenDeploymentTypeFilter = () => {
    setOpenDeploymentTypeFilter(true);
  };

  const onClickDeleteDeploy = (deployId) => {
    const deploy = deployments?.data?.find((d) => d.deploymentID === deployId);
    if (deploy) {
      setDeployToDelete(deploy);
      if (deploy.file && deploy.file.assetDescription) {
        setYesNoDialogText(`You are about to cancel deployment of asset ${deploy.file.type} ${deploy.file.assetDescription.version}. Are you sure?`);
      } else if (deploy.file && deploy.file.metaData) {
        setYesNoDialogText(`You are about to cancel deployment of asset ${deploy.file.type} ${deploy.file.metaData.version}. Are you sure?`);
      } else {
        setYesNoDialogText(`You are about to cancel deployment of asset ${deploy.file.type}. Are you sure?`);
      }
      setYesNoDialogOpen(true);
    } else {
      openAlert('Deployment can\'t be found', 'The requested deployment could\'t be found', 'closeAlertDeleteDeploymentNotFoundError');
    }
  };

  const classes = useStyles();
  const handlePageChange = (event, value) => {
    setCurrentPage(value - 1);
  };

  const handleSelectChange = (event) => {
    setPageSize(event.target.value);
  };

  if (!project) {
    return <MessageCard message="No project selected" />;
  }

  if (errorFetchingDeployments) {
    return (
      <SimpleAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        header="Error"
        body={errorFetchingDeployments.message}
        id="closeAlertErrorFetchingDeployments"
      />
    );
  }

  // When filtering by deploymentId, always expand the accordion
  const isFilteringByDeploymentId = !!_debouncedDeploymentId;

  return (
    <Box>
      <YesNoDialog
        open={yesNoDialogOpen}
        setOpen={setYesNoDialogOpen}
        header="Cancel deployment"
        body={yesNoDialogText}
        action={() => deleteDeploy(deployToDelete)}
        actionName="Yes"
        id="confirmationDeleteDeploy"
      />
      <SimpleAlert open={alertOpen} setOpen={setAlertOpen} header={alertHeader} body={alertText} id={alertId} />
      <PageBanner
        title="ASSETS DEPLOYMENTS"
      />
      {(isLoading || !project?.code) && (
        <ProgressDialog open header="Retrieving deployments, please wait" />
      )}

      <Box style={{ padding: 16 }}>
        <AssetManagementFiltersBar
          title="Filters"
          projectCode={project?.code}
          onSearch={handleSearchClick}
          onFilterDelete={handleFilterChipDelete}
        filters={[
          {
            type: 'search',
            name: 'deploymentId',
            label: 'Deployment ID',
            placeholder: 'Search by deployment ID',
            size: 'large',
          },
          {
            type: 'search',
            name: 'description',
            label: 'Description',
            placeholder: 'Search by description',
            size: 'large',
          },
          {
            type: 'select',
            name: 'status',
            label: 'Status',
            options: [
              { value: '0', label: 'Active' },
              { value: '1', label: 'Deleted' },
            ],
            hideAllOption: true,
            default: true,
            size: 'small',
          },
          {
            type: 'select',
            name: 'sortDirection',
            label: 'Sort by Date',
            options: [
              { value: 'ASC', label: 'Ascending' },
              { value: 'DESC', label: 'Descending' },
            ],
            size: 'small',
          },
          ...(deploymentFileTypes?.data?.length > 0 && !isLoadingDeploymentFileTypes
            ? [
                {
                  type: 'select',
                  name: 'assetTypes',
                  label: 'Asset Type',
                  options: deploymentFileTypes.data,
                  multiple: true,
                },
              ]
            : []),
        ]}
        activeFilters={{
          deploymentId: filterByDeploymentId,
          description: filterByDescription,
          status: deleted.toString(),
          sortDirection,
          assetTypes: selectedDeploymentFileTypes,
        }}
        onFilterChange={(name, value) => {
          if (name === 'deploymentId') {
            setFilterByDeploymentId(value);
          } else if (name === 'description') {
            setFilterByDescription(value);
          } else if (name === 'status') {
            setDeleted(parseInt(value, 10));
          } else if (name === 'sortDirection') {
            setSortDirection(value);
          } else if (name === 'assetTypes') {
            setSelectedDeploymentFileTypes(value);
            setDeploymentFileTypeFilter(value.length > 0 ? value.join(',') : null);
          }
        }}
        onClearAll={() => {
          setFilterByDescription('');
          setDebouncedDescription('');
          setFilterByDeploymentId('');
          setDebouncedDeploymentId('');
          setDeleted(0);
          setSortDirection('DESC');
          setSelectedDeploymentFileTypes([]);
          setDeploymentFileTypeFilter(null);
          setIsSearchTriggered(true);
        }}
      />
      </Box>

      {
        deployments?.data?.length > 0 ? (
          deployments?.data?.map((deployment, i) => (
            <DeploymentAccordion
              deployment={deployment}
              key={deployment.deploymentID}
              id={`pageBannerDeploymentList${i}`}
              deleted={deleted === '1'}
              deleteDeploy={onClickDeleteDeploy}
              expandedProp={isFilteringByDeploymentId} // Always expand if filtering by deploymentId
              onDeploymentUpdate={refetch} // Pass refetch function to trigger data refresh
            />
          ))
        ) : (
          <MessageCard message="No deployments retrieved" />
        )
      }

      <div className={classes.tableIcons}>
        {deployments?.pagination && !_debouncedDeploymentId && ( // hide pagination if is filtering by Deployment ID

          <PaginationComponent
            pageSize={pageSize}
            handleSelectChange={handleSelectChange}
            pagination={deployments.pagination}
            handlePageChange={handlePageChange}
          />

        )}
      </div>

    </Box>
  );
}
